<template>
<div>

  <lls-tabs v-model="activeTab" class="tabs">
    <lls-tab-pane 
      v-for="(tab, index) in tabArr" 
      :key="index" 
      :label="tab.name" 
      :name="tab.id" 
    >
    <!-- Message -->
    <template v-if="tab.name === 'Message'">
      <span slot="label">

        {{ $t('message.message') }}
        <lls-badge 
          v-if="countObj.unReadCount && countObj.unReadCount > 0" 
          :value="countObj.unReadCount" 
          :max="99"
          class="badge-sty">
        </lls-badge>
       
      </span>
    </template>
    
    <!-- TO_DO -->
    <template v-else>
      <span slot="label">
        {{ $t('message.todo') }}
        <lls-Badge 
          v-if="countObj.unHandleCount && countObj.unHandleCount > 0" 
          :value="countObj.unHandleCount" 
          :max="99"
          class="badge-sty">
        </lls-Badge>
       
      </span>
    </template>
  </lls-tab-pane>
  
</lls-tabs>

<div class="tabs-content" >
  <!-- {{ countObj }} -->
  <template  >
    <Table 
      key="1"
      v-show="activeTab === '1'"
      :msgType="1"
      @refreshCount="$emit('refreshCount')" 
      :countObj="countObj">
    </Table>
  </template>
  <template>
    <Table
      key="2"
      v-show="activeTab === '2'"
      :msgType="2"
      @refreshCount="$emit('refreshCount')" 
      :countObj="countObj">
    </Table>
  </template>
 
</div>
 
</div>
</template>

<script>

import Table from './coms/Table.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      currentPage1: 1,
      input2: '',
      tabArr: [{
        name: 'Message',
        id: '1'
      }, {
        name: "To-do",
        id: '2'
      }],
      activeTab: '1',
      multipleSelection: [],
    }
  },
  props: {
    countObj: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Table
  },
  mounted() {
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  }
}
</script>

<style scoped lang="scss">
.tabs {
  margin: 0 24px;
  border-bottom: 1px solid #F2F4F7;
  ::v-deep{
    .lls-tabs__item {
      height: 39px;
    }
    .lls-tabs__header {
      margin: 0
    }
  }
}

.badge-sty {
  ::v-deep {
    sup {
      top: 0;
      display: flex;
      align-items: center;
      margin-left: 2px;
    }
  }
}
.notificate-title {
  color: #4E78B1;
  font-size: 18px;
  font-weight: 700;
}
.tabs-content {
  overflow: auto;
  color: #000;
}

</style>
